module.exports = __webpack_public_path__ + "static/media/processB.b19072eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/processB.svg
// module id = 557
// module chunks = 0